import React, { useEffect, useState } from 'react'
import System from "../../../../../helper/system";
import Helper from 'src/helper/Helper';
import { useOrderStore } from 'src/hooks/order';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/helper/Constants';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import orderinsiteuser from "src/assets/images/order-insite-user.svg";
import orderinsitebilling from "src/assets/images/order-insite-billing.svg";
import orderinsiteshipping from "src/assets/images/order-insite-shipping.svg";
import orderinsiteshippingmethod from "src/assets/images/order-insite-shipping-method.svg";

const OrderInfoListing = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ order_detail }, { fetch_order_detail }, { order_download_invoice }] = useOrderStore();
    const isCoreUser = System.avUserInfoData.currentUser === Constants.siteUser.CORE
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [monitorFunctionCall, setMonitorFunctionCall] = useState({
        monitorJs: false,
        frameworkReady: false
    })

    useEffect(() => {
        async function fetchHere() {
            await getOrderDetail()
        }

        fetchHere()
    }, []);

    const getOrderDetail = async () => {
        const { order_number: SalesOrderNumber = '', web_order_number: WebOrderId = '' } = System.getParams();

        const res = await fetch_order_detail({ SalesOrderNumber, WebOrderId })
        if (!monitorFunctionCall?.frameworkReady || !monitorFunctionCall?.monitorJs) {
            System.monitorFrameWorkReady()
            System.monitorJSDx()
            setMonitorFunctionCall({ ...monitorFunctionCall, frameworkReady: true, monitorJs: true })
        }

        if (Object.keys(res?.payload)?.length === 0) {
            system_alert_indicator({
                name: "orderDetailNotFound",
                message: "Sorry! No Order Result Found.",
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true,
            });
        }
    }

    const downloadInvoice = async (invoiceNumber) => {
        const result = await order_download_invoice(invoiceNumber);
        if (result) {
            system_alert_indicator({
                name: 'DownloadOrder',
                message: Constants.downloadMsg,
                type: "success"
            })
        }

    }

    const renderAddress = (address) => {
        if (address) {
            return (
                <div>
                    <p>
                        {Helper.valueIsNotNull(address?.address1) && address?.address1}
                        {Helper.valueIsNotNull(address?.address2) && address?.address2}<br />
                        {Helper.valueIsNotNull(address?.city) && address?.city + ", "}
                        {Helper.valueIsNotNull(address?.stateName) && address?.stateName + " "}
                        {Helper.valueIsNotNull(address?.postalCode) && address?.postalCode}<br />
                        {Helper.valueIsNotNull(address?.countryName) && address?.countryName}
                    </p>
                </div>
            )
        } else { return <></> }
    };

    const getOrderType = (type) => {
        return type === "OffLine" ? "Offline" : "Online"
    }

    return (
        <>
            {__check(['GET_ORDER_DETAIL']).render}
            {
                !__check(['GET_ORDER_DETAIL']).status &&
                order_detail && Object.keys(order_detail).length > 0 &&

                <div className="order-information-wrapper">
                    <div className="order-information container-fluid maxw100 ">
                        <h4 className="heading mt-3 mb-0 font-18 lh-sm">Order Information</h4>
                        <div className="bs5 row order-information-row">
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className='font-13 font-arial'><strong className="text-black">P.O. Number </strong></div>
                                <div className='font-13 font-arial'>{order_detail?.poNumber && order_detail?.poNumber.trim() !== '' ? order_detail?.poNumber : '-'}</div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className='font-13 font-arial'><strong className="text-black">Web Order Number</strong></div>
                                <div className='font-13 font-arial'>{order_detail?.webOrderNumber && order_detail?.webOrderNumber.trim() !== '' ? order_detail?.webOrderNumber : '-'}</div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className='font-13 font-arial'><strong className="text-black">Sales Order Number</strong></div>
                                <div className='font-13 font-arial'>{order_detail?.salesOrderNumber && order_detail?.salesOrderNumber.trim() !== '' ? order_detail?.salesOrderNumber : '-'}</div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className='font-13 font-arial'><strong className="text-black">Order Status</strong></div>
                                <div className='font-13 font-arial'>{order_detail?.orderStatus && order_detail?.orderStatus.trim() !== '' ? order_detail?.orderStatus : '-'}</div>
                            </div>
                        </div>
                        <div className="bs5 row order-information-row bg-grey pb-2">
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><img src={orderinsiteuser} className="me-2" /> Buyer Contact Information</div>
                                <div className="head-desc">
                                    <div className='font-13 font-arial'>{order_detail?.buyerInfo?.name && order_detail?.buyerInfo?.name.trim() !== '' ? order_detail?.buyerInfo?.name : '-'}</div>
                                    <div className='font-13 font-arial'>{order_detail?.buyerInfo?.address?.emailId && order_detail?.buyerInfo?.address?.emailId.trim() !== '' ? order_detail?.buyerInfo?.address?.emailId : ''}</div>
                                    <div className='font-13 font-arial'>{order_detail?.buyerInfo?.address?.phoneNo && order_detail?.buyerInfo?.address?.phoneNo.trim() !== '' ? order_detail?.buyerInfo?.address?.phoneNo : ''}</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><img src={orderinsitebilling} className="me-2" /> Billing Address</div>
                                <div id="ord_details_billing">
                                    <div className="head-desc">
                                        {
                                            order_detail?.billTo && Object.entries(order_detail?.billTo).length > 0 &&
                                            <>
                                                <div className='font-13 font-arial'>{order_detail?.billTo.name}</div>
                                                {renderAddress(order_detail?.billTo?.address)}
                                            </>
                                        }
                                    </div>
                                </div>
                                <p />
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"> <img src={orderinsiteshipping} className="me-2" /> Shipping Address</div>
                                <div id="ordDetailShipAddr">
                                    <div className="field">
                                        <div className="head-desc">
                                            {
                                                order_detail?.shipTo && Object.entries(order_detail?.shipTo).length > 0 &&
                                                <>
                                                    <div className='font-13 font-arial'> {order_detail?.shipTo.name}</div>
                                                    {renderAddress(order_detail?.shipTo?.address)}
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><img src={orderinsiteshippingmethod} className="me-2" /> Shipping Method</div>
                                <div>
                                    <div className="head-desc">
                                        <div>{order_detail?.shippingMethod && order_detail?.shippingMethod.trim() !== '' ? order_detail?.shippingMethod : ''}</div>
                                        <div>{order_detail?.shippingMethodDesc && order_detail?.shippingMethodDesc.trim() !== '' ? order_detail?.shippingMethodDesc : ''}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bs5 row order-information-row p-0">
                            <div className="col-6 col-md-6 col-lg-3 border-right py-2">
                                <div className="head">Invoice</div>
                                {order_detail?.invoiceNo && order_detail?.invoiceNo.length > 0 ?
                                    <>
                                        {order_detail.invoiceNo.length <= 2 ?
                                            order_detail.invoiceNo.map((v, i) => {
                                                if (i < 2) {
                                                    return <div className="mb-2">
                                                        <i className="fa fa-download me-1" aria-hidden="true" />
                                                        <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                            onClick={() => downloadInvoice([v])}>{v} </a>
                                                        <input type="hidden" id="invoiceUrlGeneration1" />
                                                    </div>
                                                }
                                            }) :
                                            <div className="mb-2">
                                                <a href={void (0)} aria-label="InvoiceGenerationlink" data-toggle="modal" data-target="#ViewAllInvoices" onClick={() => {
                                                    System.popup('OrderDetailViewInvoicesPopup', {
                                                        invoiceData: order_detail.invoiceNo,
                                                        poNumber: order_detail.poNumber
                                                    });
                                                }}>View All Invoices </a>
                                            </div>
                                        }
                                    </> :
                                    '-'
                                }
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 border-right py-2">
                                <div className="head">Tracking/Waybill Number </div>
                                {order_detail.trackingDetails && order_detail.trackingDetails.length > 0 ?
                                    <div id="tracking_55640725">
                                        {order_detail.trackingDetails.length <= 2 ?
                                            order_detail.trackingDetails.map((v, i) => {
                                                if (i < 2) {
                                                    return <div key={i}>
                                                        {v.trackingUrl ?
                                                            <a href={v.trackingUrl} target='_blank'><p className='text-blue'>{v?.trackingNo}</p></a> :
                                                            <p className='text-black'>{v?.trackingNo}</p>}
                                                    </div>
                                                }
                                            }) :
                                            <div className="mb-2">
                                                <a onClick={() => System.popup('OrderDetailViewAllTrackingPopup', { trackingDetails: order_detail.trackingDetails, poNumber: order_detail.poNumber })}>View all Tracking</a>
                                            </div>
                                        }
                                    </div> :
                                    '-'
                                }
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 border-right py-2">
                                <div className="head">Payment Method</div>
                                <div className="bs5 row padding0">
                                    {order_detail?.paymentType === "Credit Card" && <div className="col-sm-12 col-md-6">
                                        <div className='font-13 font-arial mb-1'><strong className="text-black">Credit Card</strong></div>
                                        <div className='d-flex align-items-center'>
                                            {order_detail?.creditCardType && <span dangerouslySetInnerHTML={{ __html: Helper.getCreditCardDetails(order_detail?.creditCardType?.toLowerCase())?.icon }} />}
                                            <span className='font-13 font-arial ms-2'>{order_detail?.creditCardType && order_detail?.creditCardType.trim() !== '' ? Helper.getCreditCardDetails(order_detail?.creditCardType?.toLowerCase())?.name : '-'}</span>
                                        </div>
                                    </div>}
                                    {isCoreUser && <div className="col-sm-12 col-md-6">
                                        <div className='font-13 font-arial'><strong className="text-black">Terms Account Information</strong></div>
                                        <div>
                                            <div className='font-13 font-arial'>{order_detail?.accountNo && order_detail?.accountNo.trim() !== '' ? order_detail?.accountNo : '-'}</div>
                                        </div>
                                    </div>}
                                    <div className="col-sm-12 col-md-6 pe-0">
                                        <div className='font-13 font-arial'><strong className="text-black">Order Tax Exemption</strong></div>
                                        <div>
                                            <div className='font-13 font-arial'>{order_detail?.taxExempt && order_detail?.taxExempt.trim() !== '' ? order_detail?.taxExempt : 'No'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 py-2">
                                <div className="head">Additional Information</div>
                                <div className="bs5 row padding0">
                                    <div className="col-sm-12 col-md-6">
                                        <div className='font-13 font-arial'><strong className="text-black">Order Type</strong></div>
                                        <div className='font-13 font-arial'>
                                            {order_detail?.orderType && order_detail?.orderType.trim() !== '' ? getOrderType(order_detail?.orderType) : '-'}
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-6">
                                        <div className='font-13 font-arial'><strong className="text-black">Order Date</strong></div>
                                        <div className='font-13 font-arial'>
                                            {order_detail.orderDate ? Helper.convertOrderModuleDateFormat(order_detail.orderDate) : '-'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default OrderInfoListing